import React from "react";
import { Badge } from "@chakra-ui/react";

const STATUS_CONFIG = {
  completed: { label: "Completed", colorScheme: "green" },
  in_progress: { label: "In progress", colorScheme: "blue" },
  not_started: { label: "Not started", colorScheme: "gray" },
  no_survey: { label: "No survey", colorScheme: "red" },
};

const ReportStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.no_survey;

  return <Badge colorScheme={config.colorScheme}>{config.label}</Badge>;
};

export default ReportStatusBadge;
